import { getUrlParam } from '@/utils/util';

const BASE_ENV = process.env.BASE_ENV
let userid = getUrlParam('Uid')
let key = getUrlParam('Key')
let appid = getUrlParam('AppId')
const secretList = {
  404: BASE_ENV !== 'prod' && BASE_ENV !== 'prev' ? 'password404' : '3a57b2ca0eb94b7aa6d8ae6db53ec8b5',
  41002: BASE_ENV !== 'prod' && BASE_ENV !== 'prev' ? 'password1' : 'cadf5e64a2ef46b9be0873767dcf2173',
  41003: BASE_ENV !== 'prod' && BASE_ENV !== 'prev' ? 'password1' : '26bb01fbfcc841288434131bab4696fe'
}
export const headers = {
  'x-k7-userid': userid,
  'x-k7-sessionkey': key,
  'x-k7-appid': appid || '404',
  secret: secretList[appid] || secretList['404']
}
const baseURL = `//${BASE_ENV === 'prod' || BASE_ENV === 'prev' ? '' : BASE_ENV + '-'}api.k7.cn/`;

const GAME = baseURL + 'game/'
const MALL = baseURL + 'mall/'
const RECHARGE = baseURL + 'recharge/'
const ACCOUNT = baseURL + 'account/'
const ACTIVITY = baseURL + 'activity/'
const USER = baseURL + 'user/'
const QUEST = baseURL + 'quest/'
const apiConfig = {
  base: {
    aliyunSlider: ACCOUNT + 'web/aliyun_slider', //阿里云滑块对接
    getUserInfo: ACCOUNT + 'web/info', //用户缓存信息
    getUserBaseInfo: USER + 'center/baseinfo', //用户缓存信息
    getMsgCode: USER + 'sms_code', // 获取手机验证码
    getUserBindMobile: USER + 'phone_num', // 获取手机验证码
    telVerify: USER + 'center/password/tel_verify', // 修改密码前手机验证
  },
  regist: {
    aliyunSlider: baseURL + 'account/web/aliyun_slider', //阿里云滑块对接
    getMobileCode: baseURL + 'account/web/login/mobile/sms', // 获取手机验证码
    register: baseURL + 'account/web/register/mobile', // 注册
    checkUserName: baseURL + 'account/web/info/user_name', // 验证用户名
    setPassword: baseURL + 'user/password',
    getPwdSms: baseURL + 'user/password/sms_code',
    afdNickname: baseURL + 'afd/green/text/scan', // 昵称审核(同盾)
    nickname: baseURL + 'user/nickname', // 昵称重复检测
  },
  team: {
    getGame: GAME +  'data',
    teams: GAME + 'teams',
    userInfo: GAME + 'team/job',
    createTeam: GAME + 'team/creation',
    checkApply: GAME + 'team/check_apply',
    getTeamDetail: id => GAME + 'team/' + id,
    joinTeam: id => GAME + 'team/' + id,
    getTeamRank: id => GAME + 'team/ranking/' + id,
    getTeamBaseInfo: id => GAME + 'team/basic_info/' + id,
    putTeamBaseInfo: id => GAME + 'team/basic_info/' + id,
    putTeamBulletin: id => GAME + 'team/bulletin/' + id,
    getTeamDonateInfo: id => GAME + 'team/donate_info/' + id,
    getTeamDonateLog: id => GAME + 'team/donate_log/' + id,
    putBuildTeam: id => GAME + 'team/donate_wealth/' + id,
    putRemoveMenber: id => GAME + 'team/kick_member/' + id,
    getMemberList: id => GAME + 'team/member/' + id,
    putChangeJob: id => GAME + 'team/change_job/' + id,
    getApplyList: id => GAME + 'team/apply_user/' + id,
    postApplyUser: id => GAME + 'team/apply_user/' + id,
    getTeamGoodsList: id => GAME + 'team/item/' + id,
    postAwardDistribution: id => GAME + 'team/member_reward/' + id,
    getExpandInfo: id => GAME + 'team/expand_info/' + id,
    putExpandInfo: id => GAME + 'team/expand/' + id,
    getMemberReward: id => GAME + 'team/member_reward/' + id,
    postMemberReward: id => GAME + 'team/member_reward/' + id,
    getTeamRewardList: id => GAME + 'team/reward/' + id,
    putTeamReward: id => GAME + 'team/reward/' + id,
    getCity: GAME + 'team/city',
    getTeamGame: GAME + 'team/match',
    getTeamScore: GAME + 'team/score',
    getUserScore: GAME + 'team/personal_score',
    getScoreDetail: GAME + 'team/score_detail',
    putQuitTeam: id => GAME + 'team/quit/' + id,
  },
  monthCard: {
    userMonthCards: MALL + 'user_month_cards',
    buy: id => MALL + 'mall_item/' + id,
    receiveAward: id => MALL + 'user_month_cards/' + id,
  },
  pay: {
    userLabels: baseURL + 'individual/user/labels', //用户标签
    scenes: baseURL + 'individual/user/scene', //场景标签
    productList: RECHARGE + 'web/list', // 充值方案列表
    rechargeInfo: RECHARGE + 'pc/info', // 充值方案详情
    rechargeLimit: RECHARGE + 'web/limit', // 检测用户是否可提额
    order: RECHARGE + 'web/order', // 创建订单
    recharge: RECHARGE + 'web/limit/increase', // 充值提额
    alipay: RECHARGE + 'web/pay/alipay', // 生成支付宝二维码
    wechat: RECHARGE + 'web/pay/wechat', // 生成微信二维码
    fuioupay: RECHARGE + 'agg/pay/fuiou', //富友支付创建订单
    furuyunpay: RECHARGE + 'agg/pay/furuyun', //付如云支付创建订单
    fastmoneypay: RECHARGE + 'agg/pay/99bill', //快钱支付创建订单
    yoppay: RECHARGE + 'agg/pay/yoppay', //易宝支付创建订单
    getOrderState: ({ orderId }) => RECHARGE + `web/order/${orderId}`, // 获取订单状态信息
    rechargeLimitVerify: RECHARGE + 'web/limit/verify', // 验证身份证和验证码
    usable: baseURL + 'afd/payment/usable', //自动选择支付方式
  },
  login: {
    login: baseURL + 'account/web/login/user_name', //账号密码登录
    aliyunSlider: baseURL + 'account/web/aliyun_slider', //阿里云滑块对接
    getCode: baseURL + 'account/web/login/mobile/sms', //获取登录验证码
    codeLogin: baseURL + 'account/web/login/mobile'//验证码登录
  },
  verified: {
    verified: ACCOUNT + 'safety/real_name_auth', // 实名认证
  },
  signin: {
    signin: id => ACTIVITY + 'signin/' + id,
    repairItem: ACTIVITY + 'signin/repair_item',
    signinAward: ACTIVITY + 'signin/award',
  },
  bankPwd: {
    bankPwd: USER + 'center/update/bank/password'
  },
  mail: {
    mails: USER + 'mail',
    mail: id => USER + 'mail/' + id,
    getMailAttachment: id => USER + `mail/${id}/attachment`,
    getAllMailAttachment: USER + 'mail/attachment',
  },
  bindMobile: {
    bindMobile: USER  + 'phone_num'
  },
  cardExchange: {
    exchange: ACTIVITY + '/giftcard/exchange'
  },
  task: {
    quest: id => QUEST + id,
  },
  fanfanle: {
    // 剩余抽奖次数
    userWealth: baseURL + 'activity/lottery/user_wealth',
    propsItem: baseURL + 'activity/lottery/opportunities',
    lotteryOnce: id => baseURL + 'activity/lottery/' + id,
    lottery: baseURL + 'activity/lottery/times',
    results: baseURL + 'activity/lottery/results',
    userRank: baseURL + 'activity/ranking/period/user_data',
    userVipInfo: baseURL + 'user/center/vipinfo',
    quest: id => baseURL + 'quest/' + id,
    rankList: (rankingId, periodId) =>  baseURL + 'activity/ranking/' + rankingId + '/' + periodId,
  },
  setAuditionAddr: {
    setAuditionAddr: baseURL + 'user/center/useraudition'
  },
  afd: {
    usable: baseURL + 'afd/payment/usable'
  }
}

export default apiConfig
